import DOMPurify from 'isomorphic-dompurify'

const config = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'scrolling'],
}

export default defineNuxtPlugin({
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.directive<HTMLElement, string | null | undefined>('sane-html', {
      mounted(el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value ?? '', config)
      },
      updated(el, binding) {
        if (binding.value !== binding.oldValue) {
          el.innerHTML = DOMPurify.sanitize(binding.value ?? '', config)
        }
      },
      getSSRProps(binding) {
        return { innerHTML: DOMPurify.sanitize(binding.value ?? '', config) }
      },
    })
  },
})
